import { jsx as _jsx } from "react/jsx-runtime";
import { QuantityChip } from './QuantityChip';
/** Not revokable receipted quantity chip. */
const ReceiptedQuantityChip = ({ availableQuantity, receiptedQuantity }) => {
    return (_jsx(QuantityChip, { size: "medium", variant: "outlined", color: getChipColor(availableQuantity), label: receiptedQuantity, 
        // title={`${t('cancel.receipt.label')} (-)`}
        tabIndex: -1 }));
};
const getChipColor = (availableQuantity) => (availableQuantity ? 'yellow' : 'success');
export { ReceiptedQuantityChip };
